import { render, staticRenderFns } from "./myNews.vue?vue&type=template&id=649a4b25&scoped=true&"
import script from "./myNews.vue?vue&type=script&lang=js&"
export * from "./myNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a4b25",
  null
  
)

export default component.exports